import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { connect } from 'react-redux';
import GreyBin from '../../svgs/permit/GrayBin'
import LoadingPage from "../Loading";
import { deleteWatchAlert, fetchWatchEvent, updateEventById } from "../../services/watches.service";
import { handleFilterDate } from "../../actions/actionsDateTime";
import DropdownMenu, { conditionColorDict } from '../DropdownMenu'
import { alertConditionsList, isPrintWhiteMode, isSmartTagShowDangerZone, isSmartTagShowDangerZoneAlertOnly, isWatchDangerZone, isWatchDisplayStandStill, watchLatOffset, watchLngOffset } from "../../config";
import LocationPopup from "../LocationPopup";
import { DEVICE_TYPE } from "../../dto/devices";

const CHART_TITLE = [
    { title: 'Item', field: null, flex: 1 },
    { title: 'Date-Time', field: '', flex: 2 },
    { title: 'Serial Number', field: 'deviceID', flex: 4 },
    { title: 'Name', field: 'name', flex: 4 },
    { title: 'Type', field: 'type', flex: 2 },
    { title: 'Danger Zone', field: 'zone', flex: 2 },
    { title: 'Location', field: '', flex: 2 },
    { title: 'Condition', field: 'condition', flex: 2 },
    { title: 'Action', field: '', inData: false, flex: 2 },
]

function RoundUpToDecimal(value, decimalPlaces) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.ceil(value * factor) / factor;
}

const WatchAlertList = forwardRef((props, ref) => {
    const isWhiteMode = props.isReport && isPrintWhiteMode;
    const [ChartData, setChartData] = useState([])
    const [targetDelete, setTargetDelete] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const filterDate = (searchParams.get('date') || 'Today')
    const filterFrom = searchParams.get('from')
    const filterTo = searchParams.get('to')
    useEffect(() => {
        fetchData()
    }, [props.alertArr, searchParams])
    useImperativeHandle(ref, () => ({
        obtainData
    }));
    const obtainData = () => {
        return ChartData
    }

    async function fetchData() {
        //console.log(props.alertArr)
        if (props.alertArr) return setChartData(props.alertArr)
        const filter = {}
        if (filterDate) filter['time'] = handleFilterDate(filterDate)
        if (filterFrom && filterTo) filter['time'] = handleFilterDate('', filterFrom, filterTo)
        filter["projectId"] = props.control.projectId
        const res = await fetchWatchEvent(props.token.token, filter, { limit: 9999, sort: { time: -1 } })
        if (res.errno) return
        //console.log(res.result)
        setChartData(res.result)
    }
    function formatType(str) {
        const obj = {
            "WATCH_SOS": 'SOS Alert',
            "WATCH_HEARTRATE": "Heart Rate",
            "WATCH_BLD_OXYGEN": "Blood Oxygen",
            "WATCH_FALLDOWN": "Fall Alert",
            "WATCH_DNG_ZONE": "Danger Zone",
            "WATCH_STANDSTILL": "Stand Still"
        }
        return obj[str]
    }
    async function handleDelete() {
        setIsLoading(true)
        const res = await deleteWatchAlert(props.token.token, targetDelete._id)
        if (props.fetchData) {
            props.fetchData()
        } else {
            fetchData()
        }
        setTargetDelete(null)
        setIsLoading(false)
    }
    const handleUpdateCondition = (event) => async (item, index) => {
        setIsLoading(true)
        const res = await updateEventById(props.token.token, event._id, { condition: item })
        if (res.errno) { alert(res.message || 'error'); return }
        if (props.fetchData) {
            props.fetchData()
        } else {
            fetchData()
        }
        setIsLoading(false)
    }
    //location popup params
    const [isShowLocationPopup, setisShowLocationPopup] = useState(false);
    const handleShowLocationPopup = (item, index) => () => {
        if(item.data.Latitude === undefined || item.data.Longitude === undefined) {
            alert('No location data available for this alert.');
            return;
        }
        let d = item
        d.data.latitude = parseFloat(d.data.Latitude) || 0;
        d.data.longitude = parseFloat(d.data.Longitude) || 0;
        setisShowLocationPopup(d)
    }
    const handleCloseLocationPopup = () => { setisShowLocationPopup(null) }
    //locaiton popup params
    return (
        <div className="py-[32px] px-[30px]">
            <div className="flex flex-row py-[16px] mt-5">
                {CHART_TITLE.map((obj, i) => (
                    <div key={'title' + obj.title} className="table_header" style={{ flex: obj.flex || 1, flexShrink: obj.srink ? 2 : 0, color: isWhiteMode ? '#000' : '#fff' }}>
                        {obj.title}
                    </div>
                ))}
            </div>
            {targetDelete &&
                <div className='fixed inset-0 flex justify-center items-center' style={{ backdropFilter: 'blur(5px)', zIndex: 999 }}>
                    <div className='p-[24px] bg-[#363636B2] rounded-[8px] flex flex-col text-white relative max-h-[95%] min-w-[350px]' style={{ border: '.5px solid #FFFFFF80', overflowY: 'auto' }}>
                        <div className='flex flex-row items-center space-between w-full'>
                            <div className='font-bold'>Confirm Delete Alert?</div>
                        </div>
                        <div className='absolute top-[24px] right-[24px] font-bold ml-20 cursor-pointer select-none' onClick={() => setTargetDelete(null)}>X</div>

                        <div className='flex flex-row items-center space-between w-full mt-10'>
                            <div className='text-sm flex-1'>Name:</div>
                            <div className='text-sm flex-2'>{targetDelete.name}</div>
                        </div>
                        <div className='flex flex-row items-center space-between w-full mt-5'>
                            <div className='text-sm flex-1'>Alert Time:</div>
                            <div className='text-sm flex-2'>{targetDelete?.time ? new Date(targetDelete.time).toLocaleString() : '-'}</div>
                        </div>
                        <div onClick={handleDelete} className='button_blue w-full mt-10' style={{ padding: '6px 0px' }}>
                            Delete
                        </div>
                    </div>
                    {isLoading && <LoadingPage />}
                </div>
            }
            {ChartData.length > 0 && ChartData.map((items, idx) =>
                <div key={idx} className="table_row" style={{ overflowWrap: 'break-word', backgroundColor: idx % 2 === 1 ? '#FFFFFF1D' : 'transparent', overflow: 'visible', color: isWhiteMode ? '#000' : '#fff' }}>
                    {CHART_TITLE.map((h, i) =>
                        <div key={h.item + 'inner' + i} className="table_item" style={{ flex: h.flex, overflow: 'visible' }}>{
                            h.title === 'Fall Alert' ? (items.data[h.field] == 11 ? 'True' : '~') :
                                h.title === 'Stand Still' ? (items[h.field] == 'WATCH_STANDSTILL' ? 'True' : '~') :
                                    h.inData ? (items.data[h.field] || '~') :
                                        h.title === 'Item' ? idx + 1 :
                                            h.title === 'Date-Time' ? (<div className="w-full flex flex-col text-[10px]">
                                                {new Date(items?.time)?.toLocaleString()?.split(' ')[0]}<br />{new Date(items?.time)?.toLocaleString()?.split(' ')[1]}
                                            </div>) :
                                                h.title === 'Type' ? formatType(items[h.field]) :
                                                    (h.title === 'Action' && props.control?.permissions?.SUMMARY_HIDE_ALERT) ? <GreyBin className='cursor-pointer' onClick={() => setTargetDelete({ ...items, idx })} /> :
                                                        // h.title === 'Event' ? <EventTypeComp TF={Math.random() <= 0.5}/> :
                                                        h.title === 'Location' ? <div className="text-[10px] cursor-pointer" onClick={handleShowLocationPopup(items)}>
                                                            <div className="">Lat: {typeof items.data.Latitude === 'number' ? RoundUpToDecimal((items.data.Latitude + (isWatchDangerZone ? watchLatOffset : 0)),5) : '~'}</div>
                                                            <div className="">Lng: {typeof items.data.Longitude === 'number' ? RoundUpToDecimal((items.data.Longitude + (isWatchDangerZone ? watchLngOffset : 0)),5) : '~'}</div>
                                                        </div> :

                                                            h.title === 'Condition' ?
                                                                (props.control?.permissions?.WATCH_EDIT ?
                                                                    <div className="w-full"><DropdownMenu showColor={true} select={handleUpdateCondition(items)} minWidth={100} isFullWidth={true} value={items?.condition || 'Pending'} options={alertConditionsList} /></div>
                                                                    : <div style={{ color: conditionColorDict[items?.condition || 'Pending'] }}>{items?.condition || 'Pending'}</div>
                                                                )
                                                                : h.title==='Danger Zone' ? (items.data[h.field] || items?.[h.field]|| '-')
                                                                : (items[h?.field]) || '-'
                        }
                        </div>)}
                </div>)}
            {isLoading && <LoadingPage />}
            {isShowLocationPopup&&<LocationPopup close={handleCloseLocationPopup} data={isShowLocationPopup} isHidePopup={true} type={DEVICE_TYPE.WATCH}/>}
        </div>)
})

export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
}, null, null, { forwardRef: true })(WatchAlertList)